import styled from 'styled-components';

import { pxToRem } from '../../lib/utils';

export const StyledFooter = styled.footer`
  padding: ${({ theme }) => pxToRem(theme.sizes.edgeSpacing)};
  color: ${({ theme }) => theme.colors.a};
  text-align: center;
  background: ${({ theme }) => theme.colors.b};
  border-top: 1px solid ${({ theme }) => theme.colors.d};
`;

export const StyledTitle = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.headings};
  font-size: ${pxToRem(16)};
  font-weight: 700;
`;

export const StyledText = styled.p`
  margin: 0;
  font-size: ${pxToRem(14)};
`;
